module.exports = __webpack_public_path__ + "img/landing-mcafee-logo.14f6e40.png";